// extracted by mini-css-extract-plugin
export default {"Indicator":"_Indicator--XJhl6","ToggleSwitch":"_ToggleSwitch--L0hum","HasFailed":"_HasFailed--yTeUJ"};